export enum IhmExpandCollapseLevel {
  HIGHEST = 'Highest',
  MID = 'Mid',
  LOW = 'Low'
}
